import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { swiperOptions } from '@src/components/swiper/base-swiper/swiper-options';
import { computed, observable, reaction } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import { useLayerData } from '@src/utils/hooks/use-layer-data';
import { useEffect, useRef } from 'react';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const language = getLanguageByPath();
class SixthPageStore extends BaseStore {
  constructor({ ...rest } = {}) {
    super();
    Object.assign(this, rest);
  }

  @observable isActive = false;

  baseSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      ...swiperOptions.default,
      autoplay: false,
      loop: true,
      loopAdditionalSlides: 1
    }
  });

  @computed
  get activeIndex() {
    return this.baseSwiperStore.activeIndex;
  }

  @observable
  featureList = [
    {
      /**
       * 视频地址
       */
      video_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1750085044595_1749733550164_byzc01.mp4',
      /**
       * 标题
       */
      feature_title: '彈幕交織，光刃相接 高速機動下的陸空作戰'
    },
    {
      /**
       * 视频地址
       */
      video_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1750085044595_1749733550164_jbDIY02.mp4',
      /**
       * 标题
       */
      feature_title: '塗裝改造，深度訂製 每一處細節都交由你打造'
    },
    {
      /**
       * 视频地址
       */
      video_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1750085044595_1749733550164_msmk03.mp4',
      /**
       * 标题
       */
      feature_title: '搜索、清除、撒離 突入危險群島，解除世界危機'
    },
    {
      /**
       * 视频地址
       */
      video_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1750085044595_1749733550164_jxyDIY04.mp4',
      /**
       * 标题
       */
      feature_title: '訂製駕駛員，巡遊基地 戰鬥之餘，體驗駕駛員日常'
    }
  ];

  playInAnimate() {
    this.isActive = true;
  }

  leaveInAnimate() {
    this.isActive = false;
  }

  initFeatureListData() {
    this.featureList.forEach((item, index) => {
      item.video_cover = require(`./images/video-cover/${index}.jpg`);
      item.title_img = require(`./images/${language}/${index}/title.png`);
      item.feature_id = index + 1;
    });
  }

  use() {
    this.videoWrapper = useRef();

    const funlinkData = useLayerData('part6');
    this.initFeatureListData();
    useEffect(
      () => {
        if (funlinkData) {
          // this.featureList = funlinkData?.featureList;
        }

        this.videoWrapper.current.querySelectorAll('.silent-video').forEach(video => {
          const fn = () => {
            video.removeEventListener('canplaythrough', fn);
            video.dataset.canplay = true;
            video.muted = true;
            const index = +video.getAttribute('data-index');
            if (index === this.activeIndex) {
              video.play().catch(() => {});
            }
          };
          video.addEventListener('canplaythrough', fn);

          video.addEventListener('ended', () => {
            this.baseSwiperStore.goNext();
          });
        });

        reaction(
          () => this.activeIndex,
          () => {
            this.videoWrapper.current.querySelectorAll('.silent-video').forEach(video => {
              if (!video.dataset.canplay) return;
              const index = +video.getAttribute('data-index');
              if (index === this.activeIndex) {
                video.currentTime = 0;
                video.muted = true;
                video.play().catch(() => {});
              } else if (!video.paused) {
                video.pause();
              }
            });
          }
        );
      },
      [funlinkData]
    );
  }
}
export default SixthPageStore;
